import React from 'react';
import {
  Box,
  Button,
  IconButton,
  Icons,
  Modal,
  Tooltip,
  Typography,
  useTheme,
} from '@ublend-npm/aulaui-core';
import { createStyles } from './PostCard.styles';
import { CANCEL, CLOSE, DELETE, COMMON_ROOM_TEXT } from './text';

type DeletePostDialogProps = {
  open: boolean;
  loading?: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const DeletePostDialog = ({
  open,
  loading = false,
  onClose,
  onConfirm,
}: DeletePostDialogProps) => {
  const styles = createStyles(useTheme() as any);

  return (
    <Modal open={open} onClose={loading ? undefined : onClose}>
      <Box sx={styles.dialog}>
        <Box sx={styles.dialogHeader}>
          <Typography sx={styles.title} id="delete-post-title" tabIndex={0}>
            {COMMON_ROOM_TEXT.deletePostTitle}
          </Typography>
          <IconButton
            aria-label={COMMON_ROOM_TEXT.closeDeleteDialog}
            onClick={onClose}
            sx={styles.closeButton}
            disabled={loading}
          >
            <Tooltip title={CLOSE}>
              <Icons.Close />
            </Tooltip>
          </IconButton>
        </Box>

        <Typography component="div" sx={styles.body} tabIndex={0}>
          {COMMON_ROOM_TEXT.deletePostConfirmation}
        </Typography>

        <Box sx={styles.footer}>
          <Button
            kind="secondary"
            type="button"
            sx={styles.buttonSx}
            onClick={onClose}
            disabled={loading}
          >
            {CANCEL}
          </Button>
          <Button
            kind="primary"
            type="button"
            sx={styles.buttonSx}
            onClick={onConfirm}
            disabled={loading}
            loading={loading}
          >
            {DELETE}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default DeletePostDialog;
